import { put, call, takeLatest, select, spawn, delay, all } from 'redux-saga/effects';
import {
	fetchWalletSuccess,
	fetchWalletError,
	loadWalletSuccess,
	loadWalletError,
	walletRefundListSuccess,
	walletRefundListError,
	walletRefundSuccess,
	walletRefundError,
	poolWalletLoad,
	loadWallet as loadWalletAction,
	setPartialRefund,
} from '../actions/wallet';
import {
	showPaymentGateway,
} from '../actions/payment';

import {
	FETCH_WALLET,
	LOAD_WALLET,
	CAPTURE_WALLET_PAYMENT,
	FETCH_WALLET_REFUND_LIST,
	PROCESS_WALLET_REFUND,
	POOL_WALLET_LOAD,
	LOAD_WALLET_UPI,
} from '../actions/types';
import {
	fetchWallet as fetchWalletAPI,
	loadWallet as loadWalletAPI,
	capturePayment as capturePaymentAPI,
	fetchWalletRefundList as fetchWalletRefundListAPI,
	processWalletRefund as processWalletRefundAPI,
} from '../services/wallet';
import { showErrorMsg, showSuccessMsg } from '../actions/snackbar';
import { validateSession } from './session';
// import { processPaytmAddMoney } from '../services/payment';
import { logErrors } from './log';
import { checkPaymentStatus as checkPaymentStatusAPI, validateVpa as validateVpaAPI } from '../services/payment';
import { setSelectedPaymentError, resetVerification, pgAddMoney } from '../actions/payment';
import { firebase } from '../context/firebase';

function* fetchWallet(action = {}) {
	const { mobile } = action.payload || {};
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, fetchWalletAPI, mobile, sessionId);
		yield put(fetchWalletSuccess(res));
	} catch (error) {
		yield put(fetchWalletError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* loadWallet(action) {
	const { paymentMethod, mobile, amount } = action.payload;
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(
			validateSession,
			loadWalletAPI,
			{
				...paymentMethod,
				mobile,
				amount,
				payment_gateway: paymentMethod.paymentType === 'cards' ? 'juspay' : paymentMethod.name,
				deviceType: process.env.REACT_APP_DEVICE_TYPE || '',
				imei: '',
			},
			sessionId
		);
		if (paymentMethod.paymentType === 'cards') {
			return (window.location.href = res.url);
		}

		if ((paymentMethod.name === 'razor_pay') && (!res.status || !res.pg_data)) {
			if(firebase) {
				firebase.analytics().logEvent('payment_failure', { payment_type: paymentMethod.name , amount });
			}

			//FIXME: Use some std error code mechanism...
			let err_code = 6001;
			if (!res.pg_data) err_code = 6002;

			throw new Error(err_code+': Error while processing payment');
		}
		
		//FIXME: S+V:: Move to server...
		if (paymentMethod.name === 'razor_pay') {
			/*
			const rp_res = yield call(validateSession, initRazorPayPaymentAPI, action.payload, sessionId);

			//console.log(rp_res);
			if (!rp_res.status) {
				throw new Error('Error while processing payment');
			} else {
				yield put(showPaymentGateway({...rp_res, pg_data: res.pg_data}));
				return;
			}
			*/
			yield put(showPaymentGateway(res));
			return;
		}

		if ((paymentMethod.name === 'PayTM_WALLET' || paymentMethod.name === 'Ola') && !res.status) {
			if (firebase && paymentMethod.name === 'PayTM_WALLET') {
				firebase.analytics().logEvent('paytm_load_money_initiated', { amount });
			}

			const { data } = res;
			if (!data) {
				throw new Error('Error while processing payment');
			}

			const newPaymentMethod = {
				...paymentMethod,
				data,
			};

			if (paymentMethod.name === 'Ola') {
				const { form, url = '' } = res.data;
				if (!form || !url) {
					throw new Error('Error while processing payment');
				}
				newPaymentMethod.data = {
					...newPaymentMethod.data,
					data: form,
				};
			}

			return yield put(
				pgAddMoney({
					...action.payload,
					paymentMethod: newPaymentMethod,
					param: 'w',
				})
			);
		}

		if (paymentMethod.name === 'payu_collect' || (paymentMethod.name === 'upi' && res.url && res.status)) {
			return yield put(
				poolWalletLoad({
					reqPayload: { ...action.payload, txn_id: res.txn_id, orderId: res.order_id },
					upiUrl: res.url,
				})
			);
		}

		yield put(loadWalletSuccess(res));
		yield put(showSuccessMsg('Wallet loaded successfully', 4000));
	} catch (error) {
		// console.log(error);
		yield spawn(logErrors, error.toString(), {
			api: loadWalletAPI.name,
			body: action.payload,
		});
		yield put(loadWalletError(error));
		yield put(showErrorMsg(error.message, 20000));
	}
}

function* capturePayment(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(validateSession, capturePaymentAPI, action.payload, sessionId);
		yield put(loadWalletSuccess(res));
		yield put(showSuccessMsg('Wallet loaded successfully', 4000));
	} catch (error) {
		yield put(loadWalletError(error));
		yield put(showErrorMsg(error.message, 20000));
	}
}

function* fetchWalletRefundList(action) {
	try {
		const { mobile } = action.payload || {};
		const { sessionId } = yield select((state) => state.auth || {});
		const { gatewayBalance = {}, refundable_balance = 0 } = yield call(
			validateSession,
			fetchWalletRefundListAPI,
			mobile,
			sessionId
		);
		yield put(
			walletRefundListSuccess({
				gatewayBalance:
					refundable_balance > 0
						? Object.values(gatewayBalance).map((data) => ({
								...data,
								refund_amount: data.refund_amount > refundable_balance ? refundable_balance : data.refund_amount,
						  }))
						: [],
				refundable_balance,
			})
		);
	} catch (error) {
		yield put(walletRefundListError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* processWalletRefund(action) {
	try {
		const { payload: { mobile, amount, gateway, fingerPrint } = {} } = action;
		if (!mobile || !amount || !gateway || !fingerPrint) {
			throw new Error('Insufficient data provided');
		}

		const { sessionId } = yield select((state) => state.auth || {});
		const res = yield call(
			validateSession,
			processWalletRefundAPI,
			{
				user_id: mobile,
				amount,
				gateway,
				finger_print: fingerPrint,
			},
			sessionId
		);

		const { partial, status, ...data } = res;

		if (partial) {
			return yield put(setPartialRefund(data));
		}
		yield put(walletRefundSuccess(res));
		yield put(
			showSuccessMsg(
				`₹${amount} refunded successfully.
    ${
			gateway === 'juspay'
				? 'Transaction might take upto 3-5 days to reflect in the bank statement depending on the bank.'
				: ''
		}`,
				4000
			)
		);
	} catch (error) {
		yield put(walletRefundError(error));
		yield put(showErrorMsg(error.message));
	}
}

function* checkWalletLoadStatus(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		const { reqPayload: { paymentMethod, mobile, amount, txn_id, orderId } = {} } = action.payload;
		const { saveVpa = true, vpa, name } = paymentMethod;
		let res = null;
		let req = {
			payment_method: name,
			mobile: mobile,
			amount: amount,
			deviceType: process.env.REACT_APP_DEVICE_TYPE || '',
			txn_id,
			orderId,
			vpa: saveVpa ? vpa : '',
			param: 'w',
		};
		const startTime = Date.now();
		while (true) {
			const { cancelPooling } = yield select((state) => state.wallet || {});
			const endTime = Date.now();
			if (cancelPooling || endTime - startTime > 1000 * 60 * 5) {
				throw new Error('Transaction failed. \n Amount if any debited will reflect in wallet');
			}

			yield delay(2000);
			res = yield call(validateSession, checkPaymentStatusAPI, req, sessionId);
			const { status, msg, retry = false } = res;
			if (!retry) {
				if (!status) {
					throw new Error(msg || 'Error while processing payment. Please try again');
				}
				break;
			}
		}

		yield put(loadWalletSuccess(res));
		yield put(showSuccessMsg('Wallet loaded successfully', 4000));
	} catch (error) {
		yield put(walletRefundError(error));
		yield put(showErrorMsg(error.message, 20000));
	}
}

function* loadWalletUpi(action) {
	try {
		const { paymentMethod, mobile, amount, imei = '' } = action.payload;
		const { sessionId } = yield select((state) => state.auth || {});
		const { vpa = {} } = paymentMethod;
		const res = yield call(validateSession, validateVpaAPI, vpa, imei, sessionId);
		const { status } = res;
		if (!status) {
			return yield put(setSelectedPaymentError(new Error('Invalid VPA')));
		}

		yield all([put(resetVerification()), put(loadWalletAction(mobile, amount, paymentMethod))]);
	} catch (error) {
		yield put(loadWalletError(error));
		yield put(showErrorMsg(error.message, 20000));
	}
}

export function* watchWallet() {
	yield takeLatest(FETCH_WALLET, fetchWallet);
	yield takeLatest(LOAD_WALLET, loadWallet);
	yield takeLatest(CAPTURE_WALLET_PAYMENT, capturePayment);
	yield takeLatest(FETCH_WALLET_REFUND_LIST, fetchWalletRefundList);
	yield takeLatest(PROCESS_WALLET_REFUND, processWalletRefund);
	yield takeLatest(POOL_WALLET_LOAD, checkWalletLoadStatus);
	yield takeLatest(LOAD_WALLET_UPI, loadWalletUpi);
}
